import axios from './../api.js'
import Vue from 'vue'

const state = {
    enquiryUUID: null,
    enquiryDocuments: [],
    enquirySelected: null,
    enquirySelectedLog: null,
    enquiryTemp: null,
    tempEnquiry: null,
    enquirySupplyType: null
}

const getters = {
    getEnquiryUUID: state => {
        return state.enquiryUUID
    },
    getEnquiryDocuments: state => {
        return state.enquiryDocuments.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
    },
    getSelectedEnquiry: state => {
        return state.enquirySelected
    },
    getSelectedEnquiryLog: state => {
        return state.enquirySelectedLog
    },
    getEnquiryTemp: state => {
        return state.enquiryTemp
    },
    getEnquirySupplyType: state => {
        return state.enquirySupplyType
    }
}

const mutations = {
    addEnquiryUUID: (state, id) => {
        state.enquiryUUID = id
        state.enquiryDocuments = []
        state.enquirySelected = null
        state.enquirySelectedLog = null
    },
    enquiryDocumentAdd: (state, obj) => {
        state.enquiryDocuments.push(obj)
    },
    detachEnquiryDocument: (state, obj) => {
        state.enquiryDocuments.splice(obj, 1)
    },
    addSelectedEnquiry: (state, obj) => {
        state.enquirySelected = obj.enquiry
        state.enquirySelected.requestId = obj.res.requestId
        state.enquirySelected.requestVersionStamp = obj.res.requestVersionStamp
        state.enquiryTemp = state.enquirySelected
    },
    updateSelectedEnquiry: (state, obj) => {
        if (!obj.request.ownerUserId) {
            obj.request.ownerUserId = ''
        }
        state.enquirySelected = obj.request
        state.enquirySelectedLog = obj.requestLogList
        if (obj.documentList.length > 0) {
            state.enquiryDocuments = []
            obj.documentList.forEach((file) => {
                if (file.contentType.startsWith('image/')) {
                    axios.downloadDocument('/Request/GetRequestThumbnail', {
                        RequestId: state.enquiryUUID,
                        RequestDocumentId: file.requestDocumentId,
                        ThumbnailWidth: 180,
                        ThumbnailHeight: 180,
                        Crop: true
                    })
                        .then((response) => {
                            let blob = new Blob([response.data], { type: file.contentType })

                            state.enquiryDocuments.push({
                                id: file.requestDocumentId,
                                dateCreated: file.created,
                                name: file.originalFileName,
                                contentType: file.contentType,
                                icon: null,
                                dataSource: window.URL.createObjectURL(blob),
                                photoTaken: file.photoTaken,
                                description: file.description,
                                shared: file.shared,
                                origin: {
                                    name: 'enquiry',
                                    id: state.enquiryUUID
                                },

                                raw: file
                            })
                        })
                } else {
                    state.enquiryDocuments.push({
                        id: file.requestDocumentId,
                        dateCreated: file.created,
                        name: file.originalFileName,
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        shared: file.shared,
                        origin: {
                            name: 'enquiry',
                            id: state.enquiryUUID
                        },

                        raw: file
                    })
                }
            })
        }
    },
    updateCopiedEnquiry: (state, obj) => {
        if (!obj.request.ownerUserId) {
            obj.request.ownerUserId = ''
        }

        delete obj.request.address1
        delete obj.request.postalCode
        delete obj.request.city
        delete obj.request.addressGuid
        delete obj.request.locationWkt
        delete obj.request.occurrenceDateTime
        delete obj.request.taskId
        delete obj.request.receivedBy
        delete obj.request.receivedByUserId
        delete obj.request.requestId
        delete obj.request.requestStatus
        delete obj.request.requestStatusTypeId
        delete obj.request.requestVersionStamp
        delete obj.request.versionStamp

        state.enquirySelected = obj.request
    },
    updateEnquirySelectedLog: (state, payload) => {
        state.enquirySelectedLog = payload
    },
    addTempEnquiry: (state, enquiry) => {
        state.enquiryTemp = enquiry
    },
    addEnquirySupplyType: (state, businessAreaTypeId) => {
        state.enquirySupplyType = businessAreaTypeId
    }
}

const actions = {
    enquiryDocumentAdd: ({commit, dispatch}, data) => {
        if (state.enquiryUUID === null) {
            return commit('enquiryDocumentAdd', {
                id: null,
                dateCreated: new Date().toISOString(),
                name: data.file.name,
                contentType: data.file.type,
                icon: null,
                dataSource: data.file.type.startsWith('image/') ? window.URL.createObjectURL(data.file) : null,
                photoTaken: data.dataType.includes('image/') ? data.file.lastModifiedDate || new Date(data.file.lastModified) : null,
                description: null,
                shared: false,
                origin: {
                    name: 'enquiry',
                    id: null
                },

                raw: data
            })
        }

        let dateString = data.file.lastModifiedDate || new Date(data.file.lastModified)

        dateString = dateString.toLocaleString('en-GB', { timeZone: 'UTC' })
        dateString = dateString.replace(',', '')

        return axios.uploadDocument('/Request/AppendRequestDocument', state.enquiryUUID, dateString, null, data.data)
            .then((response) => {
                commit('enquiryDocumentAdd', {
                    id: response.data.requestDocumentId,
                    dateCreated: new Date().toISOString(),
                    name: data.file.name,
                    contentType: data.file.type,
                    icon: null,
                    dataSource: data.file.type.startsWith('image/') ? window.URL.createObjectURL(data.file) : null,
                    photoTaken: data.dataType.includes('image/') ? data.file.lastModifiedDate || new Date(data.file.lastModified) : null,
                    description: null,
                    shared: false,
                    origin: {
                        name: 'enquiry',
                        id: state.enquiryUUID
                    },

                    raw: data
                })
            })
            .catch((error) => {
                return new Promise((resolve, reject) => {
                    reject(error)
                })
            })
    },
    enquiryDocumentRemove: ({ commit, dispatch }, id) => {
        return axios.post('/Request/DeleteRequestDocument', { requestId: state.enquiryUUID, requestDocumentId: id }).then((response) => {
            return new Promise((resolve, reject) => {
                const file = state.enquiryDocuments.find(document => document.id === JSON.parse(response.config.data).requestDocumentId)
                const index = state.enquiryDocuments.indexOf(file)

                if (file.dataSource) {
                    window.URL.revokeObjectURL(file.dataSource)
                }
                commit('detachEnquiryDocument', index)
                resolve(response, id)
            })
        }, (error) => {
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
    },
    enquiryDocumentOpen: ({commit, dispatch}, payload) => {
        let fileData = payload
        let enquiryId = state.enquiryUUID || fileData.requestId

        if (!enquiryId && fileData.origin.name === 'enquiry' && fileData.origin.id) {
            enquiryId = fileData.origin.id
        }

        return axios.downloadDocument('/Request/GetRequestDocumentStream', {
            RequestId: enquiryId,
            RequestDocumentId: fileData.RequestDocumentId || fileData.id
        })
            .then(response => {
                return new Promise((resolve, reject) => {
                    let blob = new Blob([response.data], { type: payload.contentType })

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, payload.name)
                        resolve(blob)
                    }

                    const data = window.URL.createObjectURL(blob)
                    var link = document.createElement('a')
                    link.href = data
                    link.target = '_blank'
                    link.click()

                    resolve(blob)
                })
            })
    },
    enquiryDocumentDownload: ({commit, dispatch}, payload) => {
        let enquiryId = state.enquiryUUID || payload.raw.requestId
        let fileData = payload
        if (!enquiryId && fileData.origin.name === 'enquiry' && fileData.origin.id) {
            enquiryId = fileData.origin.id
        }

        return axios.downloadDocument('/Request/GetRequestDocumentStream', {
            RequestId: enquiryId,
            RequestDocumentId: fileData.id || fileData.raw.requestDocumentId
        })
            .then(response => {
                return new Promise((resolve, reject) => {
                    let blob = new Blob([response.data], { type: payload.contentType })

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, payload.name)
                        resolve(blob)
                    }

                    const data = window.URL.createObjectURL(blob)
                    var link = document.createElement('a')
                    link.href = data
                    if (payload.photoTaken !== null) {
                        let ext = payload.name.split('.').pop()
                        let fileName = window['moment'].utc(payload.photoTaken).local().format('YYYYMMDD[_]HHmm')

                        if (fileName !== null & ext !== null) {
                            link.download = fileName.concat('.', ext)
                        } else {
                            link.download = payload.name
                        }
                    } else {
                        link.download = payload.name
                    }
                    link.click()

                    resolve(blob)
                })
            })
    },
    enquiryDocumentDescriptionUpdate: ({ commit }, file) => {
        axios.post('/Request/SetRequestDocumentDescription', {
            requestId: state.enquiryUUID,
            requestDocumentId: file.id,
            requestDocumentVersionStamp: file.raw.requestDocumentVersionStamp,
            description: file.description
        })
            .then((response) => {
                file.raw.requestDocumentVersionStamp = response.data.requestDocumentVersionStamp
            })
            .catch((error) => {
                commit('errorHandler', error)
                throw error
            })
    },
    enquiryDocumentShareUpdate: ({ commit }, file) => {
        return axios.post('Request/SetRequestDocumentShare', {
            requestId: file.origin.id,
            requestDocumentId: file.id,
            shared: file.shared
        })
            .catch((error) => {
                commit('errorHandler', error)
            })
    },

    createUpdateEnquiry: ({ commit, dispatch }, payload) => {
        return axios.post('/Request/CreateUpdateRequest', payload)
            .then((response) => {
                return new Promise((resolve, reject) => {
                    state.enquiryUUID = response.data.requestId
                    let res = response.data
                    commit('addSelectedEnquiry', {enquiry: payload, res: res})
                    commit('successHandler', response)
                    resolve(response.data)
                })
            }, (error) => {
                commit('errorHandler', error)
            })
            .then(() => {
                const documentPromises = state.enquiryDocuments.map((document) => {
                    if (document.id) {
                        return document
                    } else {
                        return new Promise((resolve, reject) => {
                            let dateString = document.photoTaken

                            if (!dateString && document.raw.file) {
                                dateString = document.raw.file.lastModifiedDate || new Date(document.raw.file.lastModified)
                                dateString = dateString.toLocaleString('en-GB', { timeZone: 'UTC' })
                                dateString = dateString.replace(',', '')
                            }

                            axios.uploadDocument('/Request/AppendRequestDocument', state.enquiryUUID, dateString, document.description, document.raw.data)
                                .then((response) => {
                                    resolve({
                                        id: response.data.requestDocumentId,
                                        dateCreated: new Date().toISOString(),
                                        name: document.raw.file.name,
                                        contentType: document.raw.file.type,
                                        icon: document.icon,
                                        dataSource: document.dataSource,
                                        photoTaken: dateString,
                                        description: document.description,
                                        shared: document.shared,
                                        origin: {
                                            name: 'enquiry',
                                            id: state.enquiryUUID
                                        },

                                        raw: document
                                    })
                                })
                                .catch((error) => {
                                    reject(error)
                                })
                        })
                    }
                })

                Promise.all(documentPromises)
                    .then((documents) => {
                        documents = documents.filter(d => d.id !== null)
                        state.enquiryDocuments = documents
                    })
                    .catch((error) => {
                        commit('errorHandler', error)
                        throw error
                    })
            })
    },
    getEnquiry: ({ commit, dispatch }, payload) => {
        return axios.post('/Request/GetWholeRequestItem', { requestId: payload.id })
            .then((response) => {
                response.data['templateMailStandard'] = 'Din henvendelse fra d. 20. marts 2018, som omhandler "Stop i stikledning" er nu afsluttet'
                response.data['templateMailStandardNoConcern'] = 'Din henvendelse fra d. 20. marts 2018, som omhandler Stop i stikledning" er nu afsluttet vedrører ikke Aalborg Forsyning, og er derfor nu afsluttet.'
                response.data['feedbackMail'] = ''
                response.data['useStandardMail'] = false

                if (payload.copy) {
                    commit('updateCopiedEnquiry', response.data)
                } else {
                    commit('updateSelectedEnquiry', response.data)
                }

                return response
            })
            .catch((response) => {
                commit('errorHandler', response)
            })
    },
    setEnquiryStatus: ({ commit, dispatch }, data) => {
        return axios.post('/Request/SetRequestStatus', data).then((response) => {
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    // response from save enquiry
    async setEnquiryUUID ({ commit, dispatch }, id) {
        try {
            await commit('addEnquiryUUID', id)
        } catch (err) {
            throw err
        }
    },
    // link task to enquiry
    addTaskToRequest: ({ commit }, data) => {
        return axios.post('/Request/AddTaskToRequest', data).then((response) => {
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    removeTaskFromRequest: ({ commit }) => {
        return axios.post('/Request/RemoveTaskFromRequest', {requestId: state.enquirySelected.requestId}).then((response) => {
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setTempEnquiry: ({ commit, dispatch }, enquiry) => {
        commit('addTempEnquiry', enquiry)
    },
    setEnquirySupplyType: ({ commit, dispatch }, businessAreaTypeId) => {
        commit('addEnquirySupplyType', businessAreaTypeId)
    },
    // Set note til enquiry
    setEnquiryNote: ({ commit }, comment) => {
        return axios.post('/Request/CreateUpdateRequestNote', comment).then((response) => {
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
            Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: 'Noget gik galt. Prøv at tilføje noten igen'})
            return response
        })
    },
    // Slet note til enquiry
    deleteEnquiryNote: ({ commit }, comment) => {
        let commentObj = {
            'requestId': comment.requestId,
            'requestLogId': comment.requestLogId
        }
        return axios.post('/Request/DeleteRequestNote', commentObj).then((response) => {
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
            Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: 'Noget gik galt. Prøv at slette noten igen'})
            return response
        })
    },
    setEnquiryLogList: ({ commit }, enquiryId) => {
        return axios.post('/Request/GetRequestLogList', {requestId: enquiryId}).then((response) => {
            commit('updateEnquirySelectedLog', response.data)
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
            return response
        })
    },
    setDeleteEnquiry: ({ commit }, requestId) => {
        return axios.post('/Request/DeleteRequest', {requestId: requestId}).then((response) => {
            commit('successHandler', response)
            return response
        }, (response) => {
            commit('errorHandler', response)
            Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: 'Noget gik galt. Prøv at slette henvendelsen igen'})
            return response
        })
    },
    clearEnquiryUUID: ({ commit }) => {
        state.enquiryUUID = null
    },
    clearEnquiryDocuments: ({ commit }) => {
        state.enquiryDocuments = []
    },
    async printCaseHistoryRequest ({ commit }, id) {
        try {
            if (!id) {
                id = state.enquiryUUID
            }
            const response = await axios.downloadDocument('/Request/GetRequestCaseReportStream', {requestId: id})
            return new Promise((resolve, reject) => {
                let blob = new Blob([response.data], { type: 'application/pdf' })

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, 'sagsforløb_henvendelse')
                    resolve(blob)
                }

                const data = window.URL.createObjectURL(blob)
                var link = document.createElement('a')
                link.href = data
                link.download = 'sagsforløb_henvendelse'
                link.click()

                resolve(blob)
            })
        } catch (err) {
            throw err
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/enquiry/enquiry.js